import { Component, OnInit, OnDestroy, inject, HostListener } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './core/auth.service';
import { LoadingService } from './services/loading.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  private auth = inject(AuthService);
  readonly loading = inject(LoadingService);
  private checkInterval: any;

  ngOnInit() {
    // 1. Immediate token expiration check upon application launch
    this.auth.checkSession();

    // 2. Periodic background verification check every 30 seconds
    this.checkInterval = setInterval(() => {
      this.auth.checkSession();
    }, 30000);
  }

  // 3. Check token when user returns or focuses back onto the browser tab
  @HostListener('window:focus')
  onWindowFocus() {
    this.auth.checkSession();
  }

  @HostListener('document:visibilitychange')
  onVisibilityChange() {
    if (document.visibilityState === 'visible') {
      this.auth.checkSession();
    }
  }

  ngOnDestroy() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
  }
}

